import React from "react";
import { cn } from "./utils";

export default function EmptyState({ title, description = "", action = null, className = "" }) {
  return (
    <div className={cn("border border-dashed border-slate-300 bg-slate-50 px-4 py-6 text-sm", className)}>
      <p className="font-medium text-slate-800">{title}</p>
      {description ? <p className="mt-1 text-slate-600">{description}</p> : null}
      {action ? <div className="mt-3">{action}</div> : null}
    </div>
  );
}
